import { useEffect, useMemo } from 'react';
import useICS2Codelists from 'hooks/useICS2Codelists';
import { ICS2CodelistsMap } from 'store/codelists/code';

/**
 * The CL733 countries whose postcode availability indicator is `C` - the ones condition C3034 lets
 * go without a postcode on the screening facility address.
 *
 * Empty until the codelist has loaded. The schema treats an empty list as "not known yet" rather
 * than "no exceptions", and the backend enforces C3034 at submission either way.
 */
const usePostcodeOptionalCountries = (): string[] => {
    const { ics2Codelists, preloadICS2Codelists } = useICS2Codelists();

    useEffect(() => {
        preloadICS2Codelists([ICS2CodelistsMap.CL733]);
    }, [preloadICS2Codelists]);

    return useMemo(
        () =>
            (ics2Codelists?.[ICS2CodelistsMap.CL733] ?? [])
                .filter((entry) => entry.value === 'C')
                .map((entry) => entry.id),
        [ics2Codelists]
    );
};

export default usePostcodeOptionalCountries;
